<ng-container [ngSwitch]="type">
  <span *ngIf="prefix" [innerHTML]="prefix" style="margin-right: 3px"></span>

  <span *ngSwitchDefault>{{ value }}</span>

  <span *ngSwitchCase="'capitalize'">{{ value | titlecase }}</span>

  <span *ngSwitchCase="'html'" [innerHTML]="value | prSafeHtml"></span>

  <span *ngSwitchCase="'currency'">{{
    value | currency: 'EUR' : 'symbol' : '.0-0'
  }}</span>

  <span *ngSwitchCase="'percent'">{{ value | percent: '.2' }}</span>

  <span *ngSwitchCase="'percentByYear'"
    >{{ value | percent: '.2' }} nets/an</span
  >

  <span *ngSwitchCase="'date'">{{ value | date: 'shortDate' }}</span>

  <span *ngSwitchCase="'bool'">{{ value ? 'Oui' : 'Non' }}</span>

  <pr-icon
    *ngSwitchCase="'flag'"
    [name]="'fs-' + value"
    style="margin-right: 5px"
  ></pr-icon>

  <pr-risk-level-ladder
    *ngSwitchCase="'riskLevel'"
    [range]="value"
  ></pr-risk-level-ladder>

  <span *ngSwitchCase="'badge'">
    <span class="pr-badge">{{ value | titlecase }}</span>
  </span>

  <pr-progress
    *ngSwitchCase="'progress'"
    [progress]="value"
    [hidden]="!value"
  ></pr-progress>

  <span [innerHTML]="suffix" *ngIf="suffix" style="margin-left: 3px"></span>
</ng-container>
